import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { Paginated } from '../models/papginated';
import { WalletBalance, WalletTransaction } from '../models/wallet';
import { ApiService } from './api.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root',
})
export class WalletService {
    constructor(
        private readonly apiService: ApiService,
        private readonly userService: UserService,
    ) {}

    getIban() {
        return this.apiService.get<{ iban: string }>('/api/iban');
    }

    changeIban(iban: string) {
        return this.apiService.put('/api/iban', { iban }).pipe(tap(() => this.userService.refreshProUserAfterValidationScopeEdit()));
    }

    getBalance(): Observable<WalletBalance> {
        return this.apiService.get<any>('/api/wallet').pipe(map((res) => new WalletBalance(res)));
    }

    getTransactions(page: number = 1, perPage: number = 10): Observable<Paginated<WalletTransaction>> {
        const qs = ApiService.objectToQueryString({ page, perPage });
        return this.apiService.get<any>(`/api/wallet/transactions?${qs}`).pipe(
            map((res) => ({
                items: (res.items ?? []).map((item: any) => new WalletTransaction(item)),
                total: res.total,
                page: res.page,
                perPage: res.perPage,
            })),
        );
    }

    withdraw(amount: string | number): Observable<WalletTransaction> {
        return this.apiService
            .post<any>('/api/wallet/withdraw', { amount: String(amount) })
            .pipe(map((res) => new WalletTransaction(res)));
    }
}
